import $ from 'jquery';
import 'bootstrap/js/dist/alert';
import 'bootstrap/js/dist/collapse';
import 'bootstrap/js/dist/dropdown';
import 'bootstrap/js/dist/modal';
import 'bootstrap/js/dist/popover';
import 'bootstrap/js/dist/tab';
import 'bootstrap/js/dist/tooltip';

if (!globalThis.HTMLPictureElement) {
    import('picturefill');
}

let _config = globalThis['_config'] || {};

let app = {
    debug: false,
};
globalThis.app = app || {};
globalThis.app.modules =  app.modules || {};

import initModulesInScope from "../../libs/@elements/init-modules-in-scope";
app.initModules = function ($scope) {
    console.warn('\'app.initModules\' is going to be deprecated and should not be used anymore. Please import and use \'initModulesInScope\' from \'./scripts/initModulesInScope\' instead.');
    initModulesInScope($scope);
};

$.loadScript = function (url) {
    console.warn('\'$.loadScript\' is going to be deprecated and should not be used anymore. Please use \'import\' for local files or import and use \'loadScript\' for external resources.');

    return import('../../libs/@elements/load-script').then(function (loadScript) {
        return loadScript.default(url);
    });
};


/**********************************
 *
 *      Project Stuff
 *
 * ********************************/

import * as ajaxInclude from '../../scripts/ajaxInclude';
app.modules.ajaxInclude = ajaxInclude.initInScope;

import * as goToLink from '../../libs/@elements/go-to-link';
app.goToLink = goToLink.init;

import * as lazyImg from '../../libs/@elements/lazy-img';
app.modules.lazyImg = lazyImg.createInitInScope({
        base: '.js-lazy-img',
        backgroundModifier: '.js-lazy-img--bg'
    }, {
        offset: globalThis.innerHeight / 2,
        preventNative: false
    }
);

import * as floatingLabel from '../../libs/@elements/floating-labels';
app.modules.floatingLabel = floatingLabel.initInScope;

import * as parsley from '../../libs/@elements/parsley-bootstrap-validation';
app.modules.parsley = parsley.initInScope;

import * as ajaxForm from '../../libs/@elements/ajax-form';
app.modules.ajaxForm = ajaxForm.initInScope;

import * as strexBaseConfig from './scripts/strex-base-config';
app.modules.strexBaseConfig = strexBaseConfig.initInScope;

import * as strexTrack from './scripts/strex-track';
app.strexTrack = strexTrack.init;
app.modules.strexTrack = strexTrack.initInScope;

import * as strexProducts from './scripts/strex-products';

app.modules.strexProducts = strexProducts.initInScope;

import * as tooltip from './../../scripts/tooltip';
app.modules.tooltip = tooltip.initInScope;

import * as strexGeneral from './scripts/strex-general';
app.modules.strexGeneral = strexGeneral.initInScope;

import * as popover from './../../scripts/popover';
app.modules.popover = popover.initInScope;

import * as strexSummary from './scripts/summary';
app.modules.strexSummary = strexSummary.initInScope;

import {init} from '../../libs/@elements/alert-notification';
init({
    // default options
});










(function( $ ){
    "use strict";

    /* -> _config._preload = Load this functions first */
    if (_config['_preload']) {
        $.each( _config['_preload'], function( _key, _val ){
            if( typeof _val == 'boolean' && typeof globalThis.app[_key] == 'function' ){
                globalThis.app[_key]();
            }
        });
    }

    /* -> _config = Load all others (not _preload and _reload) */
    $.each( _config, function( _key, _val ){
        if( ( typeof _val == 'boolean' && typeof globalThis.app[_key] == 'function' && _key != '_reload' && _key != '_preload' ) ){
            globalThis.app[_key]();
        }
    });

    /* -> _config._reload = Load the ajaxInclued and others after the rest */
    if (_config['_reload']) {
        $.each( _config['_reload'], function( _key, _val ){
            if( ( typeof _val == 'boolean' && typeof globalThis.app[_key] == 'function' ) ){
                globalThis.app[_key]();
            }
        });
    }

    initModulesInScope();
})($);